import { SpinnerMark } from "@workspace/ui/components/atoms/spinner"

const LoadingSpinner = () => {
	return (
		<div className="flex items-start justify-center">
			<SpinnerMark size={56} />
		</div>
	)
}

export default LoadingSpinner
